import { SectionHead } from '../components/SectionHead';
import { formatCount } from '../lib/format';

interface CoverageSummary {
  accounts: number;
  untouched: number;
  withSignal: number;
  inCommunication: number;
  meetings: number;
  withMeeting: number;
}

export function MorningOverview({ owner, coverage }: { owner: string; coverage: CoverageSummary }) {
  return (
    <section className="morningoverview" aria-label="Book overview">
      <SectionHead title={owner ? `${owner.split(' ')[0]}’s book` : 'All accounts'}
        count={`${formatCount(coverage.accounts)} accounts`} />
      <div className="coveragesummary">
        <span><b>{formatCount(coverage.untouched)}</b> not yet contacted</span>
        <span><b>{formatCount(coverage.withSignal)}</b> with a signal</span>
        <span><b>{formatCount(coverage.inCommunication)}</b> in conversation</span>
        <span><b>{formatCount(coverage.meetings)}</b> meetings · all time · {formatCount(coverage.withMeeting)} account{coverage.withMeeting === 1 ? '' : 's'}</span>
      </div>
    </section>
  );
}
